import { FaDesktop, FaMobileAlt } from 'react-icons/fa';
import styled, { css } from 'styled-components';
import { ButtonIconProps, IconProps } from './HeaderPreview.types';

export const Container = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 8px 16px;
  background-color: var(--color-background-primary);
  border-radius: 8px;
`;

export const ContainerIcons = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0 8px;
  border-bottom: 1px solid var(--color-separator-light);
`;

export const DesktopIcon = styled(FaDesktop)`
  cursor: pointer;
  color: #c4c4c4;

  ${({ active }: IconProps) =>
    active &&
    css`
      color: #e26126;
    `};
`;

export const MobileIcon = styled(FaMobileAlt)`
  cursor: pointer;
  color: #c4c4c4;

  ${({ active }: IconProps) =>
    active &&
    css`
      color: #e26126;
    `};
`;

export const ButtonIcon = styled.button<ButtonIconProps>`
  display: flex;
  cursor: pointer;
  align-items: center;
  gap: 12px;
  padding: 10px 16px;
  color: #c4c4c4;
  font-size: 16px;
  font-weight: bold;
  margin: 0;
  background-color: transparent;
  border: none;
  border-bottom: 4px solid transparent;

  &:hover {
    color: var(--color-text-secondary);
  }

  ${({ active }: ButtonIconProps) =>
    active &&
    css`
      color: var(--color-text-primary);
      border-bottom: 4px solid #e26126;
    `};
`;

export const PreviewTitle = styled.p`
  color: var(--color-text-primary);
  font-size: 16px;
  font-weight: bold;
  margin: 0;
`;
